import React from "react";
import { IncorporationDetailsContainer } from "../../containers";

const IncorporationDetails = (props) => {
  return <IncorporationDetailsContainer {...props} />;
};

export default IncorporationDetails;
